import styled from 'styled-components';

const Date = styled.span`
  color: #666d71;
  display: block;
  font-size: 1.4em;
  margin: 5px 0 0 0;
  text-align: left;
`;

export default Date;